import { EnhancedImage, ImageView, createImageViewFactory } from '~/components/utilities/image-format';

const BASE_FORMAT = 'jpg';
const PNG_FORMAT = 'png';

// const setBaseFormat = (fileName) => return `${fileName.split}`

export type EnhancedAndFormattedImageView = {
	formats: {
		type: string;
		srcSet: string;
	}[];
	src: string;
	srcSet: string;
	srcSmall: string;
	srcMedium: string;
	srcLarge: string;
};

function enhanceImageView(
	imageView: ImageView,
	descriptors: string[],
	formatEnhancer: ReturnType<typeof createImageViewFactory>,
	keepOriginalFileExtension?: boolean
): EnhancedAndFormattedImageView;
function enhanceImageView(
	imageView: ImageView,
	descriptors: string[],
	formatEnhancer: null,
	keepOriginalFileExtension?: boolean
): EnhancedImage;

function enhanceImageView(
	imageView: ImageView,
	descriptors: string[],
	formatEnhancer: ReturnType<typeof createImageViewFactory> | null,
	keepOriginalFileExtension = false
) {
	if (!imageView || !descriptors) {
		return null;
	}

	const { file } = imageView;

	let srcSetFile = file;

	if (!keepOriginalFileExtension) {
		// imgSrc = `${imgSrc.split('.')[0]}.${BASE_FORMAT}`;
		// const end = test.substr(test.lastIndexOf(".") + 1);
		const format = file.substr(file.lastIndexOf('.') + 1);
		if (format === PNG_FORMAT) srcSetFile = `${file.split('.').slice(0, -1).concat(BASE_FORMAT).join('.')}`;
		// format === PNG_FORMAT ?
		// imageView.file.split('.').slice(0, -1)
	}

	const imgSrc = imageView.path ? `${imageView.path}/${file}` : '';

	const enhancedImageView = {
		src: imgSrc,
		descriptors,
		srcSet: descriptors.map(desc => `${imageView.path}/${desc}/${srcSetFile} ${desc}`).join(','),
		srcSmall: descriptors.find(desc => desc === '180w') && `${imageView.path}/180w/${srcSetFile}`,
		srcMedium: descriptors.find(desc => desc === '240w') && `${imageView.path}/240w/${srcSetFile}`,
		srcLarge: descriptors.find(desc => desc === '480w') && `${imageView.path}/480w/${srcSetFile}`
	};

	if (formatEnhancer) {
		const { imageView: formatedImageView } = formatEnhancer({
			imageView: enhancedImageView
		});

		return formatedImageView;
	}

	return enhancedImageView;
}

export default enhanceImageView;
